import { SynapseNotebookActivity, SynapseSparkJobDefinitionActivity } from 'shell-models-lib';
SynapseNotebookActivity.LINKED_SERVICE.constraint = { required: !__IS_A365__ };
SynapseSparkJobDefinitionActivity.LINKED_SERVICE.constraint = { required: !__IS_A365__ };

export { Activity, Criteria, Link, SynapseNotebookActivity, SynapseSparkJobDefinitionActivity } from 'shell-models-lib';
